import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styles from './Navbar.module.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const emailAddress = 'info@nateanne.co.za';
  const mailtoLink = `mailto:${emailAddress}`;

  // Close menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const toggleMenu = () => setMenuOpen(prev => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={styles.navbar}>
      
      {/* Logo */}
      <NavLink to="/" className={styles.logo} onClick={closeMenu}>
        Nate~Anne
      </NavLink>

      {/* Hamburger */}
      <div 
        className={`${styles.menuToggle} ${menuOpen ? styles.active : ''}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Nav Links */}
      <ul className={`${styles.navLinks} ${menuOpen ? styles.open : ''}`}>
        
        <li>
          <NavLink 
            to="/" 
            onClick={closeMenu}
            className={({ isActive }) => isActive ? styles.activeLink : styles.link}
          >
            Home
          </NavLink>
        </li>

        <li>
          <NavLink 
            to="/services" 
            onClick={closeMenu}
            className={({ isActive }) => isActive ? styles.activeLink : styles.link}
          >
            Services
          </NavLink>
        </li>

        <li>
          <NavLink 
            to="/contact" 
            onClick={closeMenu}
            className={({ isActive }) => isActive ? styles.activeLink : styles.link}
          >
            Contact
          </NavLink>
        </li>

        <li>
          <a 
            href={mailtoLink} 
            className={styles.mailButton}
            onClick={closeMenu}
          >
            Mail Us
          </a>
        </li>

      </ul>
    </nav>
  );
};

export default Navbar;
